// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://3pqjpmfparbebcc3zb4quz2zhm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_content_delivery_bucket": "amilookupv2-20191110144231-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "http://amilookupv2-20191110144231-hostingbucket-dev.s3-website-us-east-1.amazonaws.com",
    "aws_cognito_identity_pool_id": "us-east-1:07244d69-4f18-4fbf-af09-43b3791f20df",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_JpwkyBu9u",
    "aws_user_pools_web_client_id": "5fm7hsguqb8qsjdkh10mt2g2fn",
    "oauth": {}
};


export default awsmobile;
